export default __webpack_public_path__ + "static/media/unifiedLibrary.0d923f3e.svg";